export default __webpack_public_path__ + "static/media/CNo.87-4.8511841f.jpg";